var sanitaryGroups = {
    "AE": "E",
    "AR": "D",
    "AU": "A",
    "BA": "B",
    "BB": "D",
    "BH": "D",
    "BM": "D",
    "BO": "D",
    "BR": "D",
    "BY": "B",
    "CA": "C",
    "CH": "A",
    "CL": "C",
    "CN": "G",
    "CR": "D",
    "CU": "D",
    "DZ": "E",
    "EG": "E",
    "FK": "A",
    "GL": "A",
    "HK": "G",
    "IL": "E",
    "IS": "A",
    "JM": "D",
    "JO": "E",
    "JP": "G",
    "KG": "B",
    "KR": "G",
    "KW": "E",
    "LB": "E",
    "MA": "E",
    "ME": "B",
    "MK": "B",
    "MO": "G",
    "MY": "E",
    "MU": "E",
    "MX": "C",
    "NZ": "A",
    "OM": "E",
    "PE": "D",
    "PM": "A",
    "PY": "D",
    "QA": "E",
    "RS": "B",
    "RU": "B",
    "SA": "E",
    "SG": "G",
    "TH": "E",
    "TN": "E",
    "TR": "E",
    "UA": "B",
    "US": "C",
    "UY": "D",
    "ZA": "F",
    "AT": "A",
    "BE": "A",
    "BG": "A",
    "HR": "A",
    "CY": "A",
    "CZ": "A",
    "DK": "A",
    "EE": "A",
    "FI": "A",
    "FR": "A",
    "DE": "A",
    "GR": "A",
    "HU": "A",
    "IE": "A",
    "IT": "A",
    "LV": "A",
    "LT": "A",
    "LU": "A",
    "MT": "A",
    "NL": "A",
    "PL": "A",
    "PT": "A",
    "RO": "A",
    "SK": "A",
    "SI": "A",
    "ES": "A",
    "SE": "A",
    "NO": "A"
};
export default sanitaryGroups;
